var app = angular.module('navigation.navtop');
app.directive('navTop', ['$window', navTop]);

function navTop($window) {
    return {
        template: require('../templates/header.html'),
        controller: ['$rootScope', '$scope', '$state', '$document', '$timeout', 'Authentication', 'Bills', Ctrl],
        controllerAs: 'vm',
        link: postLink
    };

    function Ctrl($rootScope, $scope, $state, $document, $timeout, Authentication, Bills) {
        $scope.state = $state;
        $scope.preLoader = false;
        $scope.sliderFormPreLoader = false;
        $scope._sliderFormActive = '';
        $scope.isAuth = false;
        $scope.billsNum = 0;

        $scope.configObjLogUser = [                                                         // configs to menu
            {"sref":"pages.services({categoryId: 'all'})","name": "SERVICES.SERVICES_HEADER"},
            {"sref":"pages.history","name":"MENU.HISTORY"},
            {"sref":"pages.templates","name":"MENU.TEMPLATES"},
            // {"sref":"pages.households","name":"MENU.HOUSEHOLDS"},
            {"sref":"pages.mycards","name":"MENU.CARDS"},
            // {"sref":"pages.myelectricity","name":"MENU.MYELECTRICITY"}
        ];

        $scope.configObjNoLog = [                                                         // configs to menu
            {"scroll":"tab-1","name": "MAIN.SUBMENU.ABOUT_US","click":"setTab(1)","offset":"132","tab":1},
            {"scroll":"services","name":"SERVICES.SERVICES_HEADER","click":"setTab(1)","offset":"92","tab":1},
            {"scroll":"tab-2","name":"MAIN.SUBMENU.FAQ","click":"setTab(2)","offset":"132","tab":2},
            {"scroll":"payment-history","name":"MAIN.SUBMENU.BILLS","click":"setTab(1)","offset":"92","tab":1},
            {"scroll":"tab-4","name":"MAIN.SUBMENU.RATES","click":"setTab(4)","offset":"132","tab":4}
        ];

        $scope.activeMenuTab = null;
        $scope.activeStateLink = null;

        function escapeHandler(event) {
            if (event.key === 'Escape') {
                $scope.$apply(function() {
                    $scope.closeMob();
                });
            }
        }

        $scope.toggleMobileMenu = function() {
            $scope.mob = !$scope.mob;

            if ($scope.mob) {
                $timeout(function() {
                    var firstMenuItem;

                    if ($scope.isLogged) {
                        firstMenuItem = document.getElementById('first-menu-item-logged-in') ||
                                       document.querySelector('#mobile-menu [role="menuitem"]');
                    } else {
                        firstMenuItem = document.getElementById('first-menu-item-logged-out') ||
                                       document.querySelector('#mobile-menu [role="menuitem"]');
                    }

                    if (firstMenuItem) {
                        firstMenuItem.focus();
                    }
                }, 150);

                document.addEventListener('keydown', escapeHandler);
            } else {
                document.removeEventListener('keydown', escapeHandler);
                $timeout(function() {
                    var burgerButton = document.querySelector('.navbar-toggle');
                    if (burgerButton) {
                        burgerButton.focus();
                    }
                }, 50);
            }
        };

        $scope.closeMob = function(arg){
            $scope.mob = false;

            document.removeEventListener('keydown', escapeHandler);

            $timeout(function() {
                var burgerButton = document.querySelector('.navbar-toggle');
                if (burgerButton) {
                    burgerButton.focus();
                }
            }, 50);

            if(!$scope.mob && arg){
                $scope.setTab(arg);
            }
        };

        $scope.setTab = function (int) {
            $rootScope.info = int;
            $scope.activeMenuTab = int;

            if($state.current.name !== 'pages.main'){
                if($rootScope.useFrame && $state.current.name == 'pages.error404'){

                    $rootScope.useFrame = false;            // change $rootScope.useFrame !!!
                }

                $state.go('pages.main').then(function () {
                    $scope.setTab(int);
                })
            } else {

                $timeout(function() {
                    $scope.moveFocusToSection(int);
                }, 100);
            }
        };


        $scope.moveFocusToSection = function(tabIndex) {
            var targetSelectors = {
                1: '#tab-1, [id*="tab-1"], [du-smooth-scroll="tab-1"]',
                2: '#tab-2, [id*="tab-2"], [du-smooth-scroll="tab-2"]',
                3: '#tab-3, [id*="tab-3"], [du-smooth-scroll="tab-3"]',
                4: '#tab-4, [id*="tab-4"], [du-smooth-scroll="tab-4"]'
            };

            var selector = targetSelectors[tabIndex];
            if (selector) {
                var targetElement = document.querySelector(selector);
                if (targetElement) {
                    if (!targetElement.hasAttribute('tabindex')) {
                        targetElement.setAttribute('tabindex', '-1');
                    }
                    targetElement.focus();

                    targetElement.addEventListener('blur', function() {
                        if (targetElement.getAttribute('tabindex') === '-1') {
                            targetElement.removeAttribute('tabindex');
                        }
                    }, { once: true });
                }
            }
        };

        this.logout = function() {
            Authentication.logout()
                .then(function() {
                    $state.go('pages.main');
                })
        };

        $scope.goTop = function () {

            if($state.current.name == 'pages.main') {
                $document.scrollTopAnimated(0);

            }
        };

        function isEmpty(obj){
            for(var key in obj){
                return false
            }
            return true;
        }

        $scope.activeSliderFormPreLoader = function (active) {
            $scope.sliderFormPreLoader = !!active;
        };

        $scope.toggleSliderForm = function (type, forceClose) {
            $scope._sliderFormActive = $scope._sliderFormActive !== type && !forceClose ? type : '';
        };

        $scope.$on('$stateChangeStart', function() {
            $scope.toggleSliderForm('', true);
        });

        $rootScope.$on('$toggleSliderForm', function(e, data) {
            $scope.toggleSliderForm(data.state);
        });

        $scope.$watch(
            function () {
                return Authentication.isLogged;
            },
            function (value) {
                $scope.isLogged = value;
            }
        );

        $scope.$watch(function () { return Bills.unpaidBillsMonth; },
            function (value) {
                $scope.billsNum = value;
            }
        );

        $scope.$watch(function () { return $rootScope.info; }, function (value) {
            if (value !== undefined && value !== null) {
                $scope.activeMenuTab = value;
            }
        });

        $scope.$watch(function () { return $state.current && $state.current.name; }, function () {
            $scope.activeStateLink = $state.current ? $state.current.name : null;
        });

        $scope.isActiveScrollTab = function (tab) {
            return String($scope.activeMenuTab) === String(tab);
        };

        $scope.isActiveStateLink = function (sref) {
            if (!sref) {
                return false;
            }
            var stateName = sref.split('(')[0];
            return $state.includes(stateName);
        };
    }

    function postLink($scope, el, attr, controller) {

        $scope.logout = function() {
            controller.logout();
        };

        var sub = document.getElementsByTagName("header")[0];

        angular.element($window).bind('scroll', function () {
            angular.element(sub).css('position', 'fixed');
            angular.element(sub).css('top', '0px');
            angular.element(sub).css('z-index', '9998');
            //angular.element(sub).css("backgroundColor","rgba(247, 247, 247, 0.95)");
            //angular.element(sub).css("transition","background-color .4s .1s ease");
            //
            //if (this.pageYOffset < 5){
            //    angular.element(sub).css("backgroundColor","rgba(247, 247, 247, 0)");
            //    angular.element(sub).css("transition","background-color .4s .1s ease");
            //}
        });
    }
}

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/header/directives/navtop.directive.js
 ** module id = 250
 ** module chunks = 1
 **/